import { Tab as ChakraTab, TabProps as ChakraTabProps } from "@chakra-ui/react";

interface UnderlinedTabProps extends Omit<ChakraTabProps, "children"> {
  children: React.ReactNode;
  // Color props
  defaultColor?: string;
  selectedColor?: string;
  selectedBorderColor?: string;

  // Typography props
  fontSize?: string;
  fontWeight?: string | number;
  fontFamily?: string;

  // Spacing props
  paddingBottom?: string;
  marginTop?: string;

  // Border props
  borderWidth?: string;

  // Transition
  transition?: string;

  // Other styling
  outline?: string;
}

export function UnderlinedTab({
  children,
  defaultColor = "dune.700",
  selectedColor = "dune.dune",
  selectedBorderColor = "blaze.blaze",
  fontSize = "20px",
  fontWeight = "600",
  fontFamily = "bricolage grotesque",
  paddingBottom = "12px",
  marginTop = "8px",
  borderWidth = "2px",
  transition = "all 0.2s ease-in-out",
  outline = "none",
  ...rest
}: UnderlinedTabProps) {
  return (
    <ChakraTab
      fontFamily={fontFamily}
      fontWeight={fontWeight}
      color={defaultColor}
      transition={transition}
      fontSize={fontSize}
      pb={paddingBottom}
      outline={outline}
      mt={marginTop}
      border="2px solid transparent"
      _hover={{
        borderBottom: `${borderWidth} solid`,
        borderBottomColor: "transparent.white.10",
      }}
      _selected={{
        color: selectedColor,
        borderBottom: `${borderWidth} solid`,
        borderBottomColor: selectedBorderColor,
      }}
      {...rest}
    >
      {children}
    </ChakraTab>
  );
}
